import { EcommerceAPIApi as EcommerceApi } from '@parkingbase/ecommerce-api-dev';

import { BaseApiService } from './baseApi.service';

export class WidgetService extends BaseApiService {
  protected widgetApi: EcommerceApi;

  constructor() {
    super();
    this.widgetApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  async getDefaultWidget() {
    const response = await this.widgetApi.defaultWidget({ skipAuth: true } as any);
    return response.data;
  }
}
